import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        userIds: '=',
        list: '=',
        tmsView: '=',
        filter: '='
    },
    template: `
        <div class="form">
            <div class="row inline">
                <label class="label">{{ 'user.Bulk actions' | translate }}</label>
                <div class="items">
                    <select ng-model="vm.action" class="form-control small">
                        <option value="activation">{{ 'user.Send account activation e-mail' | translate }}</option>
                        <option value="reset" ng-if="vm.tmsView" >{{ 'user.Send password reset e-mail' | translate }}</option>
                    </select>
                    <button ng-click="vm.handleBulkAction()" class="btn bordered02">{{ 'general.Ok' | translate }}</button>
                </div>
            </div>
        </div>
    `
})
export default class {
    constructor ($translate, lodash, toastr, DATATABLES, USER_STATUS_ENUM, ModalService, UserResource) {
        this.$translate = $translate;
        this.lodash = lodash;
        this.toastr = toastr;
        this.DATATABLES = DATATABLES;
        this.USER_STATUS_ENUM = USER_STATUS_ENUM;
        this.ModalService = ModalService;
        this.UserResource = UserResource;
        this.action = 'activation';
    }

    handleBulkAction () {
        const userIds = angular.copy(this.userIds);

        if (userIds.length === 0) {
            this.toastr.error(this.$translate.instant('general.Please select users'));
        }
        else if (this.action === 'activation') {
            this.handleActivation(userIds);
        }
        else if (this.action === 'reset') {
            this.handleReset(userIds);
        }
    }

    handleActivation (userIds) {
        this.getActivationQuery({ userIds }, { validateOnly: true }).then(() => {
            const message = this.getActivationConfirmationMessage(userIds);
            this.ModalService.confirm(message, 'large').then(() =>
                this.getActivationQuery(({ userIds })).then(() => {
                    this.list.fetch(this.filter);
                    this.userIds = [];
                    this.displayResponseMessage();
                }).catch((errors) => {
                    this.displayResponseMessage(errors);
                })
            );
        }).catch((errors) => {
            this.displayResponseMessage(errors);
        });
    }

    handleReset (userIds) {
        const emailsSelected = this.getEmails(userIds).join(', ');
        const message = this.$translate.instant('general.Are you sure you want to send password reset e-mail for users {emails}',
            { emails: emailsSelected }
        );
        this.ModalService.confirm(message, 'large').then(() => {
            this.UserResource.resetPasswordBulk({ userIds }).$promise
                .then(() => {
                    this.userIds = [];
                    this.displayResponseMessage();
                })
                .catch((errors) => {
                    this.displayResponseMessage(errors);
                });
        });
    }

    getActivationQuery (post, params) {
        const query = this.tmsView ?
            this.UserResource.activateAccountBulk(params, post) :
            this.UserResource.activateExternalAccountBulk(params, post);
        return query.$promise;
    }

    /**
     * @param {array=} errors if given shows error message, else shows success msg
     */
    displayResponseMessage (errors) {
        if (errors) {
            this.lodash.forEach(errors.data, (error) => {
                this.toastr.error(error.message);
            });
        }
        else {
            this.toastr.success(this.$translate.instant('general.Emails are sent'));
        }
    }

    getActivationConfirmationMessage (userIds) {
        const activationEmailsNotSent = this.getEmails(userIds, false).join(', ');
        const partOne = activationEmailsNotSent ?
            this.$translate.instant('general.Are you sure you want to send account activation e-mail for users {emails}',
                { emails: activationEmailsNotSent }) : '';
        const activationEmailsAlreadySent = this.getEmails(userIds, true).join(', ');
        const partTwo = activationEmailsAlreadySent ?
            this.$translate.instant('general.Are you sure you want to re-send account activation e-mail for users {emails}',
                { emails: activationEmailsAlreadySent }) : '';
        return `${partOne}<br>${partTwo}`;
    }


    /**
     * This function returns all user emails that have their checkboxes checked
     * Can return 3 different outcomes depending on function argument
     * Case 1: usersWithEmailAlreadySent is not set, returns all users that have checkbox checked
     * Case 2: usersWithEmailAlreadySent is true, returns all users that have already gotten activation emails
     * Case 3: usersWithEmailAlreadySent is false, returns all users that have not gotten activation emails
     * @param {array} userIds
     * @param {boolean=} usersWithEmailAlreadySent
     */
    getEmails (userIds, usersWithEmailAlreadySent) {
        const checkedUsers = this.list.items.filter((item) => {
            return this.lodash.includes(userIds, item.id);
        });

        if (usersWithEmailAlreadySent === undefined) {
            return checkedUsers.map((item) => item.primaryEmail);
        }
        const users = checkedUsers.filter((user) => {
            const isEmailAlreadySent = this.tmsView ? user.isActivationEmailSent : user.isExternalAccountActivationEmailSent;
            return isEmailAlreadySent === usersWithEmailAlreadySent;
        });
        return users.map((item) => item.primaryEmail ? item.primaryEmail : item.displayName);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/user/bulk/index.js